/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */
import constants from '../../constants';
import Validator from '../validator';

setTimeout(() => {
  const INVALID_PHONE_MESSAGE = 'Enter a valid phone number';
  import(/* webpackChunkName: "libphonenumber" */ 'libphonenumber-js').then(({ parsePhoneNumberFromString }) => {
    Validator.register('phone', (value: string) => {
      let message: string | null = null;
      const phoneMatcher = /^\+?\d+$/;
      if (value && !phoneMatcher.test(value)) {
        message = INVALID_PHONE_MESSAGE;
      }
      const hasCountryCode = value?.startsWith('+');
      if (value && hasCountryCode) {
        const phoneNumber = parsePhoneNumberFromString(value);
        if (!phoneNumber || !phoneNumber.isPossible() || value !== phoneNumber.number) {
          message = INVALID_PHONE_MESSAGE;
        }
      }
      return message;
    });
  });
}, constants.PRIORITY.TRIVIAL);
